import { TranzilaAdditionalParams } from "../data/resource_integration";
import { isCountryIsrael } from "../lib/validation/israeli";
import { Order } from "../offering/api";
import { Locale } from "../lib/i18n/i18n_provider";

export function tranzilaIframeURL(
  tranzilaId: string,
  order: Order,
  tranzilaNotifyURLAddress: string,
  locale: Locale,
  tranzilaAdditionalParams?: TranzilaAdditionalParams
): string {
  const params = new URLSearchParams();
  params.append("tranmode", "AK");
  params.append("sum", order.totalPrice.toString());
  params.append("currency", "1"); // ILS
  params.append("order_id", order.id);
  params.append("company", order.companyName);
  params.append("contact", order.fullName);
  params.append("email", order.email);
  params.append("phone", order.phoneNumber);

  if (order.billingDetails) {
    params.append("address", order.billingDetails.streetAddress);
    params.append("city", order.billingDetails.city);
    if (isCountryIsrael(order.billingDetails.country)) {
      params.append("myid", order.billingDetails.tax);
    }
  }

  params.append(
    "success_url_address",
    `${window.location.origin}/tranzila_success_redirect`
  );
  params.append(
    "fail_url_address",
    `${window.location.origin}/tranzila_fail_redirect`
  );
  params.append("notify_url_address", tranzilaNotifyURLAddress);

  if (locale.baseLanguageTag === "he") {
    params.append("template", "custom_he");
    params.append("lang", "il");
  } else {
    params.append("template", "custom");
  }

  if (tranzilaAdditionalParams) {
    Object.entries(tranzilaAdditionalParams).forEach(([key, value]) => {
      params.append(key, value);
    });
  }

  return `https://direct.tranzila.com/${tranzilaId}/iframenew.php?${params.toString()}`;
}
